import { changePasswordApiV1AuthChangePasswordPost } from '@/common/api/client/sdk.gen'
import type {
    ChangePasswordApiV1AuthChangePasswordPostError,
    ChangePasswordApiV1AuthChangePasswordPostResponse,
    ChangePasswordRequest,
} from '@/common/api/client/types.gen'
import { useFormMutation } from '@/common/hooks/useFormMutation'

export const useChangePasswordModel = () => {
    const { form, mutation, handleSubmit, register, errors, isLoading, isSuccess, isError, error, onSubmit } =
        useFormMutation<
            ChangePasswordRequest,
            ChangePasswordApiV1AuthChangePasswordPostResponse,
            ChangePasswordApiV1AuthChangePasswordPostError
        >({
            mutationFn: data => changePasswordApiV1AuthChangePasswordPost({ body: data }).then(res => res.data!),
            toastOptions: {
                successMessage: 'Пароль успешно изменен',
                errorMessage: 'Ошибка при изменении пароля',
            },
            formOptions: {
                defaultValues: {
                    old_password: '',
                    new_password: '',
                    new_password_confirm: '',
                },
            },
        })

    return {
        form,
        changePassword: mutation,
        handleSubmit,
        onSubmit,
        register,
        errors,
        isPending: isLoading,
        isSuccess,
        isError,
        error,
    }
}
